import { useState } from 'react';
import ArticleLink from '@/components/feature/ArticleLink';
import { forexBasicsReviews } from '@/mocks/forexBasics';
import SectionHeading from '@/components/base/SectionHeading';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function KnowledgeReview() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="ทบทวนความรู้"
          title="เช็กก่อนว่าคุณเข้าใจพื้นฐานแล้วหรือยัง"
          subtitle="ลองตอบคำถามสั้น ๆ สามข้อนี้ด้วยตัวเองก่อนดูคำตอบ ถ้าตอบได้ครบ แปลว่าคุณพร้อมก้าวไปสู่การเทรดจริง"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {forexBasicsReviews.map((review, index) => {
            const isOpen = openId === review.id;
            return (
              <ScrollReveal key={review.id} delay={index * 80}>
                <article className="group flex h-full flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-all duration-300 ease-out hover:-translate-y-0.5 hover:border-primary-300">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                    <i className={`${review.icon} text-xl`} />
                  </span>

                  <span className="mt-4 text-xs font-semibold uppercase tracking-wide text-primary-600">
                    {review.title}
                  </span>
                  <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                    {review.question}
                  </h3>

                  <div className="mt-4 flex-1">
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : review.id)}
                      aria-expanded={isOpen}
                      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                    >
                      <i className={`${isOpen ? 'ri-eye-off-line' : 'ri-eye-line'} text-base`} />
                      {isOpen ? 'ซ่อนคำตอบ' : 'ดูคำตอบ'}
                    </button>

                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? 'mt-4 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="rounded-lg border border-secondary-200 bg-secondary-50/80 p-4 text-sm leading-relaxed text-foreground-700">
                          {review.answer}
                        </p>
                      </div>
                    </div>
                  </div>

                  <ArticleLink
                    to={review.link}
                    className="mt-5 flex items-center gap-1.5 border-t border-background-200 pt-4 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
                  >
                    {review.linkLabel}
                    <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" />
                  </ArticleLink>
                </article>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}